import { Link } from 'react-router-dom';
import YouTubeCounter from '../components/YouTube/YouTubeCounter';

const Landing = () => {
  return (
    <div className="landing">
      <section className="hero">
        <div>
          <h2>Welcome to Help Me DIY</h2>
          <p>
            Raffles, merch, and DIY tools — all in one place. Jump in anywhere
            and check back often for new features.
          </p>
          <div className="hero-actions">
            <Link to="/raffle">Enter the Raffle</Link>
            <Link to="/eeprom">EEPROM Tools</Link>
          </div>
        </div>
        <div className="hero-media">
          <img
            src="/images/f430-yellow.jpg"
            alt="Yellow Ferrari F430 convertible on a racetrack"
          />
        </div>
      </section>
      <div className="section-card">
        <p className="section-title">Live YouTube Stats</p>
        <YouTubeCounter />
      </div>
      <div className="landing-sections">
        <div>
          <h3>Raffle</h3>
          <p>Enter giveaways, view rules, and check status.</p>
          <Link to="/raffle">Go to Raffle</Link>
        </div>
        <div>
          <h3>Merch</h3>
          <p>Support the channel with merch and affiliate links.</p>
          <Link to="/merch">Go to Merch</Link>
        </div>
        <div>
          <h3>EEPROM Tools</h3>
          <p>Upload files and apply supported modifications.</p>
          <Link to="/eeprom">Go to EEPROM Tools</Link>
        </div>
      </div>
      <div className="landing-legal">
        <a href="/privacy-policy.html">Privacy Policy</a>
        <span>•</span>
        <a href="/terms-of-service.html">Terms of Service</a>
      </div>
    </div>
  );
};

export default Landing;
